import React from "react";
import { Upload, Button, Menu, Dropdown, InputNumber, Select, Switch, Tooltip } from "antd";
import { UploadOutlined, ForwardOutlined, DownOutlined,WarningOutlined } from '@ant-design/icons'
import "antd/dist/antd.css"
import styles from "./control.module.css"
import { MathJaxContext, MathJax } from "better-react-mathjax"
import { createRef } from "react/cjs/react.production.min";
import { block_2000 } from "./myData/block_2000";
import { bus685 } from "./myData/bus685";
import { bus1138 } from "./myData/bus1138";
import { can_96 } from "./myData/can_96";
import { dwt_1005 } from "./myData/dwt_1005"
import { fpga_dcop_07 } from "./myData/fpga_dcop_07"
import { myTem } from "./myTem";
import Graph from "../graph";
// import { MathJax, MathJaxContext } from "better-react-mathjax";
// import w from './demo'

const { Option } = Select;
export default class ControlSets extends React.Component {
    tooltipText = <span>
                    Only the "source target" format is supported currently. For example:
                    <br/>
                    0 1
                    <br/>
                    1 2
                    <br/>
                    2 0
                    <br/>
                    The corresponding graph is a triangle of nodes 0,1 and 2.
                </span>
    defaultData = "can_96"
    defaultFunction = "Balanced Stress Model"
    defaulFunctionObject = myTem(this.defaultFunction);
    isFirst = false;
    disabled = false;
    data = can_96();
    userUpload = false;
    paraArray = []
    functionGraph = createRef();
    postData = "";
    pmdsBody = "false";
    state = {
        isUpload: false,
        selectAddAlpha: false,
        selectSubAlpha: false,
        functionObject: this.defaulFunctionObject,
        pmds: false,
        selectedData: this.defaultData,
        selectedTem: this.defaultFunction
    }
    tems = [
        "Balanced Stress Model",
        "Stress Model",
        "Maxent",
        "Force-directed Placement",
        // "ForceAtlas2",
        "LinLog"
    ]
    examples = [
        "block_2000",
        "can_96",
        "dwt_1005",
        "bus1138",
        "fpga_dcop_07",
        "bus685"
    ]
    handleChange = (value) => {
        if (value === "upload") this.setState({ isUpload: true })
        else this.setState({ isUpload: false })
    }
    clickExampleData = (dataKind) => {
        return () => {
            let dataArr = []
            let { selectedData } = this.state;
            selectedData = dataKind;
            if (selectedData == "bus685") dataArr = bus685();
            if (selectedData == "block_2000") dataArr = block_2000();
            if (selectedData == "can_96") dataArr = can_96();
            if (selectedData == "dwt_1005") dataArr = dwt_1005();
            if (selectedData == "bus1138") dataArr = bus1138();
            if (selectedData == "fpga_dcop_07") dataArr = fpga_dcop_07();
            this.data = dataArr;
            this.userUpload = false;
            this.setState({ selectedData })
        }
    }
    clickSelectTem = (tem) => {
        return () => {
            let { selectedTem, functionObject, pmds } = this.state;
            selectedTem = tem;
            functionObject = myTem(tem);
            pmds = false;
            if (selectedTem == "Maxent") {
                this.pmdsBody = "true";
                pmds = true;
            }
            this.setState({ selectedTem, functionObject, pmds })
        }
    }
    changePmds = (value) => {
        if (this.disabled) return;
        this.pmdsBody = value;
        let { pmds, selectedTem } = this.state;
        pmds = !pmds;
        selectedTem = ""
        this.setState({ pmds, selectedTem })
    }
    componentDidMount() {
        // let { selectedData,selectedTem, functionObject, pmds } = this.state;
        // selectedData = this.defaultData;
        // this.userUpload = false;
        // selectedTem = this.defaultFunction;
        // functionObject = myTem(this.defaultFunction);
        // pmds = false;
        // if (selectedTem == "Maxent") {
        //     this.pmdsBody = "true";
        //     pmds = true;
        // }
        // this.setState({ selectedData, selectedTem, functionObject, pmds })
        //this.submitPara()
        // this.isFirst = false;
    }



    templete = (
        <Menu>
            {this.tems.map((item, index) => {
                return <Menu.Item key={index}>
                    <a key={item} onClick={this.clickSelectTem(item)}>
                        {item}
                    </a>
                </Menu.Item>
            })}
        </Menu>
    );
    menu = (
        <Menu>
            {this.examples.map((item, index) => {
                return <Menu.Item key={index}>
                    <a onClick={this.clickExampleData(item)}>
                        {item}
                    </a>
                </Menu.Item>
            })}
        </Menu>
    );
    addAlpha = () => {
        let { functionObject, bPara } = this.state;
        functionObject.nums = functionObject.nums + 1;
        this.setState({ functionObject })
    }
    subAlpha = () => {
        let { functionObject } = this.state;
        let { omegaPara, wPara, aPara, bPara } = functionObject;
        functionObject.nums = functionObject.nums - 1;
        if (functionObject.nums <= 0) functionObject.nums = 1
        if (omegaPara.length > 1) {
            omegaPara.pop();
            wPara.pop()
            aPara.pop()
            bPara.pop()
        }
        this.setState({ functionObject })
    }
    mouseEnter = (icon) => {
        return () => {
            if (icon === "addAlpha") {
                this.setState({ selectAddAlpha: true })
            }
            if (icon === "subAlpha") {
                this.setState({ selectSubAlpha: true })
            }
        }
    }
    mouseLeave = () => {
        return () => {
            let selectAddAlpha = false;
            let selectSubAlpha = false;
            let selectAddR = false;
            let selectSubR = false;
            this.setState({ selectAddAlpha, selectSubAlpha, selectAddR, selectSubR })
        }
    }
    changePara = (index, kind) => {
        return (value) => {
            if (this.disabled) return;
            let { functionObject, selectedTem } = this.state;
            const { omegaPara, wPara, aPara, bPara } = functionObject;
            if (kind === "omegaPara") omegaPara[index] = value;
            if (kind === "wPara") wPara[index] = value;
            if (kind === "aPara") aPara[index] = value;
            if (kind === "bPara") bPara[index] = value;
            selectedTem = "";
            this.setState({ functionObject, selectedTem })
        }
    }
    submitPara = () => {
        let map = {
            "": 0,
            "Balanced Stress Model": 1,
            "Stress Model": 2,
            "Maxent": 3,
            "Force-directed Placement": 4,
            "ForceAtlas2": 6,
            "LinLog": 5,
            "V2Value": 0,
            "EValue": 1,
            "SValue": 2,
            "NPValue": 3,
            "true": 1,
            "false": 0
        };

        let wasPara = "";
        let selectedData = "", functionObject = "", selectedTem;
        if (!this.isFirst) {
            selectedData = this.state.selectedData;
            functionObject = this.state.functionObject;
            selectedTem = this.state.selectedTem;
        } else {
            selectedData = this.defaultData;
            functionObject = myTem(this.defaultFunction);
            selectedTem = this.defaultFunction;
        }
        if (selectedData == "" && !this.userUpload) {
            alert("Please select a data!")
            return false;
        }
        if (functionObject.nums < 2) {
            alert("parameter is not enough!");
            return;
        }
        wasPara = wasPara + map[selectedTem] + "*";
        wasPara = wasPara + functionObject.nums + ","
        for (let i = 0; i < functionObject.nums; i++) {
            if (
                functionObject.omegaPara[i] === "" || functionObject.wPara[i] === "" || functionObject.aPara[i] === "" || functionObject.bPara[i] === "" ||
                functionObject.omegaPara[i] === undefined || functionObject.wPara[i] === undefined || functionObject.aPara[i] === undefined || functionObject.bPara[i] === undefined
            ) {
                // console.log("]]]]]]]]]]]]]]]",functionObject.omegaPara[i],functionObject.wPara[i],functionObject.aPara[i],functionObject.bPara[i])
                alert("Please write the parameter !")
                return;
            }
            if (i != functionObject.nums - 1) {
                wasPara = wasPara + map[functionObject.omegaPara[i]] + ","
                    + functionObject.wPara[i] + ","
                    + functionObject.aPara[i] + ","
                    + functionObject.bPara[i] + ","
            } else {
                wasPara = wasPara + map[functionObject.omegaPara[i]] + ","
                    + functionObject.wPara[i] + ","
                    + functionObject.aPara[i] + ","
                    + functionObject.bPara[i]
            }
        }
        wasPara = wasPara + "*" + map[this.pmdsBody];
        wasPara = wasPara + "*" + this.data.length + ",";
        let pointMap = new Map();
        let reversePointMap = new Map();
        let drawData = {
            nodes: [],
            links: []
        }
        for (let i = 0; i < this.data.length; i++) {
            let line = this.data[i]
            if (!pointMap.has(line[0])) {
                pointMap.set(line[0], pointMap.size);
                reversePointMap.set(reversePointMap.size, line[0]);
            }
            if (!pointMap.has(line[1])) {
                pointMap.set(line[1], pointMap.size);
                reversePointMap.set(reversePointMap.size, line[0]);
            }
            if (i != this.data.length - 1) {
                wasPara = wasPara + pointMap.get(line[0]) + "," + pointMap.get(line[1]) + ",";
            } else {
                wasPara = wasPara + pointMap.get(line[0]) + "," + pointMap.get(line[1]);
            }
        }
        console.log("----------------------------",wasPara)
        let pending = true;
        let edgeNumber = drawData.links.length;

        let self = this;
        Graph.classObj.setState({ pending, edgeNumber });

        
        setTimeout(() => {
            let location = window.UTF8ToString(window._layout(self.toCharPtr(wasPara))).split(",");
            for (let i = 0; i < pointMap.size; i++) {

                let x = Number(location[i * 2])
                let y = Number(location[i * 2 + 1]);
                x++;
                y++;
                drawData["nodes"][i] = {
                    id: i,
                    "x": x,
                    "y": y
                }
            }
            for (let i = 0; i < self.data.length; i++) {
                let line = self.data[i]
                drawData["links"][i] = {
                    "source": pointMap.get(line[0]),
                    "target": pointMap.get(line[1])
                }
            }
            Graph.classObj.replace(drawData)
        }, 1000)

        // setTimeout(, 1);
    }

    toCharPtr = (str) => {
        const ptr = window.allocate(window.intArrayFromString(str), window.ALLOC_NORMAL);
        return ptr;
    }
    beforeSynUpload = (file, fileList) => {
        let reader = new FileReader();
        reader.readAsText(file)
        let readData = []
        let readMap = new Map();
        let self = this;
        reader.onload = function () {
            let sarr = reader.result.split("\r\n");
            if (sarr.length == 1) {
                sarr = sarr[0].split("\n");
            }
            for (let i = 0; i < sarr.length; i++) {
                let lineArr = sarr[i].split(" ");
                let from = lineArr[0];
                let to = lineArr[1];
                if (from === "" || from === undefined || to === "" || to === undefined) continue;
                if (!readMap.has(from)) {
                    readMap.set(from, readMap.size);
                }
                if (!readMap.has(to)) {
                    readMap.set(to, readMap.size);
                }
                readData[readData.length] = [readMap.get(from), readMap.get(to)];
            }
            let selectedData = "";
            self.data = readData;
            self.userUpload = true;
            self.setState({ selectedData });


        }
    }
    render() {
        const { isUpload, selectAddAlpha, selectSubAlpha, selectedData, selectedTem, pmds } = this.state;
        const { functionObject } = this.state;
        const { nums, wPara, aPara, bPara, omegaPara } = functionObject;
        let addAlphaClass = selectAddAlpha ? "selectedAddAlpha" : "addAlpha";
        let subAlphaClass = selectSubAlpha ? "selectedSubAlpha" : "subAlpha";
        let alphaFunction = [];
        for (let i = 0; i < nums; i++) {
            //alphaFunction = alphaFunction.push("\\[\\sum_{(i,j)\\in\\Omega_\\alpha}{(k_{ij}^\\alpha\\ast{\\parallel x_i-x_j\\parallel}^{p_\\alpha}/d_{ij}^{\\alpha_\\alpha})}\\]");
            if (i === 0) {
                if (wPara.length >= 1 || aPara.length >= 1 || bPara.length >= 1) {
                    let wValue = wPara[i] === undefined ? `\\omega_${i}` : wPara[i];
                    let aValue = aPara[i] === undefined ? `\\alpha_${i}` : aPara[i];
                    let bValue = bPara[i] === undefined ? ` \\beta_${i}` : " " + bPara[i];
                    alphaFunction.push(`F=\\sum_{(i,j)\\in\\Omega}{(${wValue}\\ast{\\parallel x_i-x_j\\parallel}^{${aValue}}/d_{ij}^{\\${bValue}})}`)
                } else {
                    alphaFunction.push(`F=\\sum_{(i,j)\\in\\Omega_${i}}{(\\omega_${i}\\ast{\\parallel x_i-x_j\\parallel}^{\\alpha_${i}}/d_{ij}^{\\beta_${i}})}`)
                }
            }
            if (i !== 0) {
                if (wPara.length >= 1 || aPara.length >= 1 || bPara.length >= 1) {
                    let wValue = wPara[i] === undefined ? `\\omega_${i}` : wPara[i];
                    let aValue = aPara[i] === undefined ? `\\alpha_${i}` : aPara[i];
                    let bValue = bPara[i] === undefined ? ` \\beta_${i}` : " " + bPara[i];
                    alphaFunction.push(`+\\sum_{(i,j)\\in\\Omega_${i}}{(${wValue}\\ast{\\parallel x_i-x_j\\parallel}^{${aValue}}/d_{ij}^{\\${bValue}})}`)
                } else {
                    alphaFunction.push(`+\\sum_{(i,j)\\in\\Omega_${i}}{(\\omega_${i}\\ast{\\parallel x_i-x_j\\parallel}^{\\alpha_${i}}/d_{ij}^{\\beta_${i}})}`)
                }
            }
        }
        return (
            <div className={styles["controlPanel"]}>
                <div className={styles["sourceData"]} >
                    {/**Example Data */}
                    <div>
                        <Dropdown className={styles["exampleData"]} overlay={this.menu} placement="bottomCenter" arrow={true}>
                            <Button>
                                {selectedData == "" ? "Example Data" : selectedData}
                                <DownOutlined />
                            </Button>
                        </Dropdown>
                    </div>
                    {/** Upload Data */}
                    <div>
                        
                            <Upload beforeUpload={this.beforeSynUpload} >
                                <Button className={styles["uploadData"]} icon={
                                <span>
                                    <Tooltip placement="bottom" title={this.tooltipText} color="#f50">
                                        <WarningOutlined style={{color:"#f50"}} />
                                    </Tooltip>
                                    &emsp;
                                    <UploadOutlined />
                                </span>
                            }>Select Files</Button>
                            </Upload>

                    </div>
                </div>

                <div className={styles["function"]}>
                    <div className={styles["functionTem"]}>
                        <Dropdown className={styles["exampleData"]} overlay={this.templete} placement="bottomCenter" arrow>
                            <Button>
                                {selectedTem == "" ? "Function Templetes" : selectedTem}
                                <DownOutlined />
                            </Button>
                        </Dropdown>
                    </div>


                    {/* <div className={styles["functionName"]} >
                        <MathJaxContext >
                            <MathJax>{`\\[F_i=\ \ \\]`}</MathJax>
                        </MathJaxContext>
                    </div> */}
                    <MathJaxContext >
                        {
                            alphaFunction.map((item, id) => {
                                if (id == alphaFunction.length - 1) {
                                    return <div key={id} className={id == 0 ? styles["headAlpha"] : styles["finalAlpha"]}>
                                        <MathJax
                                            renderMode={"pre"}
                                            typesettingOptions={{ fn: "tex2chtml" }}
                                            text={item}
                                            inline
                                            dynamic
                                        />
                                        {/* <PlusSquareOutlined
                                            className={styles[addAlphaClass]}
                                            onMouseEnter={this.mouseEnter("addAlpha")}
                                            onMouseLeave={this.mouseLeave()}
                                            onClick={this.addAlpha} />
                                        <MinusSquareOutlined
                                            className={styles[subAlphaClass]}
                                            onMouseEnter={this.mouseEnter("subAlpha")}
                                            onMouseLeave={this.mouseLeave()}
                                            onClick={this.subAlpha} /> */}
                                    </div>
                                }

                                return <div key={id} className={id == 0 ? styles["headAlpha"] : styles["finalAlpha"]}>
                                    <MathJax
                                        renderMode={"pre"}
                                        typesettingOptions={{ fn: "tex2chtml" }}
                                        text={item}
                                        inline
                                        dynamic
                                    />
                                </div>
                            })
                        }
                    </MathJaxContext>
                    {/* <div className={styles["finalBracket"]} >
                        <MathJaxContext >
                            <MathJax>{`\\[)*\\overrightarrow{e_{i j}}\\label{eq:rep}\\]`}</MathJax>
                        </MathJaxContext>
                    </div> */}
                    <Button type="primary" style={{ marginTop: "20px" }} onClick={this.submitPara} icon={<ForwardOutlined />}>Run This Model</Button>
                </div>
                <div className={styles["settingPara"]}>
                    <h2>Function Parameters</h2>
                    <div className={styles["pmds"]}>
                        PivotMDS init: <Switch checkedChildren="true" unCheckedChildren="false" checked={selectedTem === "Maxent" ? true : pmds} onChange={this.changePmds} disabled={this.disabled} />
                    </div>
                    {
                        alphaFunction.map((item, index) => {
                            return (
                                <div className={styles["aAlphaLine"]} key={selectedTem + index}>
                                    <div className={styles["linePara"]} >
                                        <div className={styles["linePara"]}>
                                            <div className={styles["paraName"]}>
                                                <MathJaxContext >
                                                    <MathJax>{`\\[\\Omega_${index}:\\]`}</MathJax>
                                                </MathJaxContext>
                                            </div>
                                            <Select defaultValue={omegaPara[index] == undefined ? "" : omegaPara[index]} style={{ width: 80, marginLeft: "5px" }} onChange={this.changePara(index, "omegaPara")} disabled={this.disabled}>
                                                <Option value="V2Value">V<sup>2</sup></Option>
                                                <Option value="EValue">E</Option>
                                                <Option value="SValue">S</Option>
                                                <Option value="NPValue">N*P</Option>
                                            </Select>
                                        </div>
                                        <div className={styles["linePara"]}>
                                            <div className={styles["paraName"]}>
                                                <MathJaxContext >
                                                    <MathJax>{`\\[\\omega_{${index}}:\\]`}</MathJax>
                                                </MathJaxContext>
                                            </div>
                                            <InputNumber min={-10} defaultValue={wPara[index] == undefined ? "" : wPara[index]} step={0.01} style={{ width: "80px", marginLeft: "5px" }} onChange={this.changePara(index, "wPara")} disabled={this.disabled} />
                                        </div>
                                    </div>
                                    <div className={styles["linePara"]}>
                                        <div className={styles["linePara"]}>
                                            <div className={styles["paraName"]}>
                                                <MathJaxContext >
                                                    <MathJax>{`\\[\\alpha_${index}:\\]`}</MathJax>
                                                </MathJaxContext>
                                            </div>
                                            <InputNumber min={-10} defaultValue={aPara[index] == undefined ? "" : aPara[index]} step={0.01} style={{ width: "80px", marginLeft: "5px" }} onChange={this.changePara(index, "aPara")} disabled={this.disabled} />
                                        </div>
                                        <div className={styles["linePara"]}>
                                            <div className={styles["paraName"]}>
                                                <MathJaxContext >
                                                    <MathJax>{`\\[\\beta_${index}:\\]`}</MathJax>
                                                </MathJaxContext>
                                            </div>
                                            <InputNumber min={-10} defaultValue={bPara[index] == undefined ? "" : bPara[index]} step={0.01} style={{ width: "80px", marginLeft: "5px" }} onChange={this.changePara(index, "bPara")} disabled={this.disabled} />
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }


                    {/* <Button type="primary" onClick={this.submitPara}>Submit Parameters</Button> */}
                </div>
                {/* <div ref={this.functionGraph} className={styles["functionGraph"]}>

                </div> */}
            </div>
        )
    }

}